<body class="ltr main-body leftmenu">
  <form autocomplete="off" novalidate>
    <div class="main-content side-content pt-0 ml-0">
      <div class="main-container container-fluid">
        <div class="inner-body">
          <div class="row row-sm add-form">
            <form autocomplete="off" class="p-0" novalidate [formGroup]="ExamFormReport">
              <div class="col-lg-12 col-md-12">
                <div class="card custom-card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-10">
                        <div class="d-flex align-items-center pl-3">
                          <img alt="Logo" src="../../assets/img/purse.png" class="mh-45px pb-2">
                          <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>Exam Form Report</b></h3>
                            <p class="text-muted card-sub-title mb-0">List Exam Form Report</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <button type="button" class="btn btn-primary btn-icon-text floatleft mt-1"
                                (click)="downloadTeacherData()">
                          <span style="display: flex; align-items: center;">
                            <img alt="Logo" width="20vh" src="../../assets/images/arrow (1).png"
                                 style="margin-right: 7px;">
                            File Download
                          </span>
                        </button>
                      </div>
                    </div>
                    <hr>

                    <!-- Filters in the exact cascade order -->
                    <div class="row clearfix mt-2">
                      <!-- 1. Session -->
                      <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Session</mat-label>
                          <mat-select #select232 placeholder="Session" class="colorblack"
                                      formControlName="SessionId">
                            <mat-select-filter *ngIf="select232.focused"
                                               [placeholder]="'Filter'"
                                               [displayMember]="'SnName'"
                                               [array]="sessionList"
                                               (filteredReturn)="SessionFilterList =$event">
                            </mat-select-filter>
                            <mat-option *ngFor="let item of SessionFilterList"
                                        [value]="item.SnNo">
                              {{item.SnName}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>

                      <!-- 2. Faculty -->
                      <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Faculty</mat-label>
                          <mat-select #selectFc placeholder="Faculty" class="colorblack"
                                      formControlName="Faculty"
                                      (selectionChange)="onFacultyChange($event.value)">
                            <mat-select-filter *ngIf="selectFc.focused"
                                               [placeholder]="'Filter'"
                                               [displayMember]="'FcDesc'"
                                               [array]="fcCodeList"
                                               (filteredReturn)="filteredListFcCode =$event">
                            </mat-select-filter>
                            <mat-option *ngFor="let item of filteredListFcCode"
                                        [value]="item.FcCode">
                              {{item.FcCode}} - {{item.FcDesc}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>

                      <!-- 3. Courses (multi-select) -->
                      <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Course Name</mat-label>
                          <mat-select #select29 placeholder="CoCode" class="colorblack"
                                      formControlName="course" multiple
                                      (selectionChange)="onCourseChange()">
                            <mat-select-filter *ngIf="select29.focused"
                                               [placeholder]="'Filter'"
                                               [displayMember]="'CoName'"
                                               [array]="CourseList"
                                               (filteredReturn)="filteredCourseList =$event">
                            </mat-select-filter>
                            <mat-option (click)="toggleSelectAllCourses()" [value]="null">
                              {{ isAllCoursesSelected ? 'Deselect All' : 'Select All' }}
                            </mat-option>
                            <mat-option *ngFor="let item of filteredCourseList"
                                        [value]="item.CoCgCoCode">
                              {{item.CoCgCoCode}} - {{item.CoName}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>

                      <!-- 4. Colleges (multi-select) -->
                      <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>College Name</mat-label>
                          <mat-select #select23 placeholder="CgCode" class="colorblack"
                                      formControlName="college" multiple
                                      (selectionChange)="getExamFormStudent()">
                            <mat-select-filter *ngIf="select23.focused"
                                               [placeholder]="'Filter'"
                                               [displayMember]="'CgName'"
                                               [array]="collegeList"
                                               (filteredReturn)="filteredCollegeList =$event">
                            </mat-select-filter>
                            <mat-option (click)="toggleSelectAllColleges()" [value]="null">
                              {{ isAllCollegesSelected ? 'Deselect All' : 'Select All' }}
                            </mat-option>
                            <mat-option *ngFor="let item of filteredCollegeList"
                                        [value]="item.CgCode">
                              {{item.CgCode}} - {{item.CgName}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Exam</mat-label>
                          <mat-select #select3901 placeholder="Exam Available" class="colorblack"
                                      formControlName="Exam" multiple
                                      (selectionChange)="onExamChange()">
                            <mat-select-filter *ngIf="select3901.focused"
                                               [placeholder]="'Exam Available'"
                                               [displayMember]="'EmName'"
                                               [array]="ExamAList"
                                               (filteredReturn)="filteredExamAList =$event">
                            </mat-select-filter>
                            <mat-option (click)="toggleSelectAllExams()" [value]="null">
                              {{ isAllExamsSelected ? 'Deselect All' : 'Select All' }}
                            </mat-option>
                            <mat-option *ngFor="let item of filteredExamAList"
                                        [value]="item.EmId">
                              {{item.EmCode}} - {{item.EmName}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-2" *ngIf="isBranch">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Branch</mat-label>
                          <mat-select #selectBranch placeholder="Branch" class="colorblack"
                                      formControlName="Branch" multiple
                                      (selectionChange)="getExamFormStudent()">
                            <mat-select-filter *ngIf="selectBranch.focused"
                                               [placeholder]="'Filter'"
                                               [displayMember]="'StrName'"
                                               [array]="BranchList"
                                               (filteredReturn)="filteredBranchList =$event">
                            </mat-select-filter>
                            <mat-option (click)="toggleSelectAllBranches()" [value]="null">
                              {{ isAllBranchesSelected ? 'Deselect All' : 'Select All' }}
                            </mat-option>
                            <mat-option *ngFor="let item of filteredBranchList"
                                        [value]="item.StrId">
                              {{item.StrName}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <hr>
                    <div *ngIf="Table" class="row mb-3">
                      <div class="col-auto">
                        <span class="fw-bold">Total Student Count:</span> {{ TotalAllStudents }}
                      </div>
                      <div class="col-auto">
                        <span class="fw-bold">Exam Form Submitted Student Count:</span> {{ TotalExamSubmittedRecords }}
                      </div>
                    </div>
                    <div *ngIf="Table" class="table-responsive table-container tab mt-1">
                      <table id="datatable" class="table table-bordered text-nowrap text-left">
                        <thead>
                          <tr class="text-left">
                            <th class="f600">Sr. No.</th>
                            <th class="f600">Student Name</th>
                            <th class="f600">PRN No</th>
                            <th class="f600">Exam</th>          <!-- ✅ Exam column -->
                          </tr>
                        </thead>
                        <tbody id="table_data">
                          <tr *ngFor="let item of ExamFormStudentList; let i = index;">
                            <td>{{i+1}}</td>
                            <td>{{item.RgName}}</td>
                            <td>{{item.RgNo}}</td>
                            <td>{{item.ExamName}}</td>        <!-- ✅ Exam data -->
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </form>
</body>